/**
 * CHG-052/053: lucide 아이콘 또는 커스텀 아이콘을 동적으로 렌더링
 */
import { icons } from 'lucide-react';

interface DynamicIconProps {
  name: string;
  color?: string;
  customIconPath?: string | null;  // CHG-053: 커스텀 아이콘 경로
  size?: number;
  className?: string;
}

/** kebab-case → PascalCase: "square-check" → "SquareCheck" */
function toPascalCase(s: string): string {
  return s
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}

export function DynamicIcon({ name, color, customIconPath, size = 16, className }: DynamicIconProps) {
  // 1. 커스텀 아이콘 우선
  if (customIconPath) {
    return (
      <img
        src={`/${customIconPath}`}
        width={size}
        height={size}
        alt={name}
        className={className}
        style={{ objectFit: 'contain' }}
        loading="lazy"
      />
    );
  }

  // 2. lucide 아이콘 fallback
  const pascalName = toPascalCase(name);
  const IconComponent = icons[pascalName as keyof typeof icons];
  if (!IconComponent) {
    return (
      <span
        className={className}
        style={{ color, width: size, height: size, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.75 }}
      >
        ?
      </span>
    );
  }
  return <IconComponent size={size} color={color} className={className} />;
}
